@use "u";

@layer components {
    .codeblock-wrapper {
        position: relative;

        &.wrap .code > :is(pre, code) {
            white-space: pre-wrap;
            word-break: normal;
            overflow-wrap: anywhere;
        }

        .code > pre {
            overflow: unset;
            border-radius: 0.5rem;
            padding: 1.25rem 1.5rem;
        }

        > .overlay-container {
            // must be a fixed length: a percentage `top`/`height` resolves
            // against the wrapper's height, so tall codeblocks push the
            // overlay far down instead of keeping it in the corner
            $margin: 0.75rem;

            position: absolute;
            pointer-events: none;
            inset: $margin;
            display: flex;
            align-items: flex-end;
            justify-content: flex-start;
            flex-direction: column;

            > .button-container {
                @include u.anim-prop(opacity);
                @include u.anim-dur(250ms);

                opacity: 0;
                pointer-events: auto;

            }
        }

        &:hover > .overlay-container > .button-container {
            opacity: 1;
        }
    }

    .line-numbers-container {
        counter-reset: line-number calc(var(--line-start, 1) - 1);
        display: flex;
        flex-direction: column;
    }

    .line {
        $num: var(--line-num-fg, #51597D);
        $num-active: var(--line-num-active-fg, $num);
        $max-digits: var(--num-max-digits, 1);

        &::before {
            @include u.anim-prop(color);
            @include u.anim-dur(100ms);

            counter-increment: line-number;
            content: counter(line-number);
            display: inline-flex;
            justify-content: flex-end;
            align-items: flex-start;
            box-sizing: content-box;

            // don't shift the code when the line number changes width
            width: calc($max-digits * 1ch);
            padding-inline: 1ch;
            padding-right: 2ch;
            color: $num;
            opacity: 1;
            user-select: none;
            pointer-events: none;
        }

        &:hover::before {
            color: $num-active;
        }
    }
}